import { c as J, C as R, r as Q, D as x, g as Z, u as ee, d as j } from "./resources-DFDnbwuT.mjs";
var V = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.emit = function(t) {
    }, e;
  }()
), te = new V(), re = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      return new V();
    }, e;
  }()
), G = new re(), ne = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.emit = function(t) {
      this._getLogger().emit(t);
    }, e.prototype._getLogger = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateLogger(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : te;
    }, e;
  }()
), N = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getLogger = function(t, r, n) {
      var i;
      return (i = this.getDelegateLogger(t, r, n)) !== null && i !== void 0 ? i : new ne(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : G;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateLogger = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getLogger(t, r, n);
    }, e;
  }()
), ie = typeof globalThis == "object" ? globalThis : typeof self == "object" ? self : typeof window == "object" ? window : typeof global == "object" ? global : {}, y = Symbol.for("io.opentelemetry.js.api.logs"), p = ie;
function oe(e, t, r) {
  return function(n) {
    return n === e ? t : r;
  };
}
var D = 1, ae = (
  /** @class */
  function() {
    function e() {
      this._proxyLoggerProvider = new N();
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalLoggerProvider = function(t) {
      return p[y] ? this.getLoggerProvider() : (p[y] = oe(D, t, G), this._proxyLoggerProvider.setDelegate(t), t);
    }, e.prototype.getLoggerProvider = function() {
      var t, r;
      return (r = (t = p[y]) === null || t === void 0 ? void 0 : t.call(p, D)) !== null && r !== void 0 ? r : this._proxyLoggerProvider;
    }, e.prototype.getLogger = function(t, r, n) {
      return this.getLoggerProvider().getLogger(t, r, n);
    }, e.prototype.disable = function() {
      delete p[y], this._proxyLoggerProvider = new N();
    }, e;
  }()
), Xe = ae.getInstance(), S;
(function(e) {
  e[e.NONE = 0] = "NONE", e[e.SAMPLED = 1] = "SAMPLED";
})(S || (S = {}));
var k = "0000000000000000", B = "00000000000000000000000000000000", ue = {
  traceId: B,
  spanId: k,
  traceFlags: S.NONE
}, d = (
  /** @class */
  function() {
    function e(t) {
      t === void 0 && (t = ue), this._spanContext = t;
    }
    return e.prototype.spanContext = function() {
      return this._spanContext;
    }, e.prototype.setAttribute = function(t, r) {
      return this;
    }, e.prototype.setAttributes = function(t) {
      return this;
    }, e.prototype.addEvent = function(t, r) {
      return this;
    }, e.prototype.addLink = function(t) {
      return this;
    }, e.prototype.addLinks = function(t) {
      return this;
    }, e.prototype.setStatus = function(t) {
      return this;
    }, e.prototype.updateName = function(t) {
      return this;
    }, e.prototype.end = function(t) {
    }, e.prototype.isRecording = function() {
      return !1;
    }, e.prototype.recordException = function(t, r) {
    }, e;
  }()
), A = J("OpenTelemetry Context Key SPAN");
function T(e) {
  return e.getValue(A) || void 0;
}
function se() {
  return T(R.getInstance().active());
}
function O(e, t) {
  return e.setValue(A, t);
}
function fe(e) {
  return e.deleteValue(A);
}
function ce(e, t) {
  return O(e, new d(t));
}
function M(e) {
  var t;
  return (t = T(e)) === null || t === void 0 ? void 0 : t.spanContext();
}
var le = /^([0-9a-f]{32})$/i, pe = /^[0-9a-f]{16}$/i;
function ge(e) {
  return le.test(e) && e !== B;
}
function de(e) {
  return pe.test(e) && e !== k;
}
function K(e) {
  return ge(e.traceId) && de(e.spanId);
}
function ye(e) {
  return new d(e);
}
var b = R.getInstance(), F = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.startSpan = function(t, r, n) {
      n === void 0 && (n = b.active());
      var i = !!(r != null && r.root);
      if (i)
        return new d();
      var o = n && M(n);
      return he(o) && K(o) ? new d(o) : new d();
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o, a, u;
      if (!(arguments.length < 2)) {
        arguments.length === 2 ? u = r : arguments.length === 3 ? (o = r, u = n) : (o = r, a = n, u = i);
        var s = a ?? b.active(), f = this.startSpan(t, o, s), l = O(s, f);
        return b.with(l, u, void 0, f);
      }
    }, e;
  }()
);
function he(e) {
  return typeof e == "object" && typeof e.spanId == "string" && typeof e.traceId == "string" && typeof e.traceFlags == "number";
}
var ve = new F(), _e = (
  /** @class */
  function() {
    function e(t, r, n, i) {
      this._provider = t, this.name = r, this.version = n, this.options = i;
    }
    return e.prototype.startSpan = function(t, r, n) {
      return this._getTracer().startSpan(t, r, n);
    }, e.prototype.startActiveSpan = function(t, r, n, i) {
      var o = this._getTracer();
      return Reflect.apply(o.startActiveSpan, o, arguments);
    }, e.prototype._getTracer = function() {
      if (this._delegate)
        return this._delegate;
      var t = this._provider.getDelegateTracer(this.name, this.version, this.options);
      return t ? (this._delegate = t, this._delegate) : ve;
    }, e;
  }()
), be = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      return new F();
    }, e;
  }()
), Pe = new be(), E = (
  /** @class */
  function() {
    function e() {
    }
    return e.prototype.getTracer = function(t, r, n) {
      var i;
      return (i = this.getDelegateTracer(t, r, n)) !== null && i !== void 0 ? i : new _e(this, t, r, n);
    }, e.prototype.getDelegate = function() {
      var t;
      return (t = this._delegate) !== null && t !== void 0 ? t : Pe;
    }, e.prototype.setDelegate = function(t) {
      this._delegate = t;
    }, e.prototype.getDelegateTracer = function(t, r, n) {
      var i;
      return (i = this._delegate) === null || i === void 0 ? void 0 : i.getTracer(t, r, n);
    }, e;
  }()
), P = "trace", me = (
  /** @class */
  function() {
    function e() {
      this._proxyTracerProvider = new E(), this.wrapSpanContext = ye, this.isSpanContextValid = K, this.deleteSpan = fe, this.getSpan = T, this.getActiveSpan = se, this.getSpanContext = M, this.setSpan = O, this.setSpanContext = ce;
    }
    return e.getInstance = function() {
      return this._instance || (this._instance = new e()), this._instance;
    }, e.prototype.setGlobalTracerProvider = function(t) {
      var r = Q(P, this._proxyTracerProvider, x.instance());
      return r && this._proxyTracerProvider.setDelegate(t), r;
    }, e.prototype.getTracerProvider = function() {
      return Z(P) || this._proxyTracerProvider;
    }, e.prototype.getTracer = function(t, r) {
      return this.getTracerProvider().getTracer(t, r);
    }, e.prototype.disable = function() {
      ee(P, x.instance()), this._proxyTracerProvider = new E();
    }, e;
  }()
), We = me.getInstance(), X = function(e) {
  var t = typeof Symbol == "function" && Symbol.iterator, r = t && e[t], n = 0;
  if (r) return r.call(e);
  if (e && typeof e.length == "number") return {
    next: function() {
      return e && n >= e.length && (e = void 0), { value: e && e[n++], done: !e };
    }
  };
  throw new TypeError(t ? "Object is not iterable." : "Symbol.iterator is not defined.");
}, Se = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
};
function Ye(e) {
  var t, r, n = {};
  if (typeof e != "object" || e == null)
    return n;
  try {
    for (var i = X(Object.entries(e)), o = i.next(); !o.done; o = i.next()) {
      var a = Se(o.value, 2), u = a[0], s = a[1];
      if (!Ae(u)) {
        j.warn("Invalid attribute key: " + u);
        continue;
      }
      if (!Te(s)) {
        j.warn("Invalid attribute value set for key: " + u);
        continue;
      }
      Array.isArray(s) ? n[u] = s.slice() : n[u] = s;
    }
  } catch (f) {
    t = { error: f };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return n;
}
function Ae(e) {
  return typeof e == "string" && e.length > 0;
}
function Te(e) {
  return e == null ? !0 : Array.isArray(e) ? Oe(e) : W(e);
}
function Oe(e) {
  var t, r, n;
  try {
    for (var i = X(e), o = i.next(); !o.done; o = i.next()) {
      var a = o.value;
      if (a != null) {
        if (!n) {
          if (W(a)) {
            n = typeof a;
            continue;
          }
          return !1;
        }
        if (typeof a !== n)
          return !1;
      }
    }
  } catch (u) {
    t = { error: u };
  } finally {
    try {
      o && !o.done && (r = i.return) && r.call(i);
    } finally {
      if (t) throw t.error;
    }
  }
  return !0;
}
function W(e) {
  switch (typeof e) {
    case "number":
    case "boolean":
    case "string":
      return !0;
  }
  return !1;
}
var Le = "[object Object]", Ie = "[object Null]", xe = "[object Undefined]", je = Function.prototype, Y = je.toString, Ne = Y.call(Object), De = Ee(Object.getPrototypeOf, Object), $ = Object.prototype, z = $.hasOwnProperty, c = Symbol ? Symbol.toStringTag : void 0, H = $.toString;
function Ee(e, t) {
  return function(r) {
    return e(t(r));
  };
}
function w(e) {
  if (!we(e) || Ce(e) !== Le)
    return !1;
  var t = De(e);
  if (t === null)
    return !0;
  var r = z.call(t, "constructor") && t.constructor;
  return typeof r == "function" && r instanceof r && Y.call(r) === Ne;
}
function we(e) {
  return e != null && typeof e == "object";
}
function Ce(e) {
  return e == null ? e === void 0 ? xe : Ie : c && c in Object(e) ? Re(e) : Ve(e);
}
function Re(e) {
  var t = z.call(e, c), r = e[c], n = !1;
  try {
    e[c] = void 0, n = !0;
  } catch {
  }
  var i = H.call(e);
  return n && (t ? e[c] = r : delete e[c]), i;
}
function Ve(e) {
  return H.call(e);
}
var Ge = 20;
function $e() {
  for (var e = [], t = 0; t < arguments.length; t++)
    e[t] = arguments[t];
  for (var r = e.shift(), n = /* @__PURE__ */ new WeakMap(); e.length > 0; )
    r = U(r, e.shift(), 0, n);
  return r;
}
function m(e) {
  return v(e) ? e.slice() : e;
}
function U(e, t, r, n) {
  r === void 0 && (r = 0);
  var i;
  if (!(r > Ge)) {
    if (r++, h(e) || h(t) || q(t))
      i = m(t);
    else if (v(e)) {
      if (i = e.slice(), v(t))
        for (var o = 0, a = t.length; o < a; o++)
          i.push(m(t[o]));
      else if (g(t))
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var s = u[o];
          i[s] = m(t[s]);
        }
    } else if (g(e))
      if (g(t)) {
        if (!ke(e, t))
          return t;
        i = Object.assign({}, e);
        for (var u = Object.keys(t), o = 0, a = u.length; o < a; o++) {
          var s = u[o], f = t[s];
          if (h(f))
            typeof f > "u" ? delete i[s] : i[s] = f;
          else {
            var l = i[s], _ = f;
            if (C(e, s, n) || C(t, s, n))
              delete i[s];
            else {
              if (g(l) && g(_)) {
                var L = n.get(l) || [], I = n.get(_) || [];
                L.push({ obj: e, key: s }), I.push({ obj: t, key: s }), n.set(l, L), n.set(_, I);
              }
              i[s] = U(i[s], f, r, n);
            }
          }
        }
      } else
        i = t;
    return i;
  }
}
function C(e, t, r) {
  for (var n = r.get(e[t]) || [], i = 0, o = n.length; i < o; i++) {
    var a = n[i];
    if (a.key === t && a.obj === e)
      return !0;
  }
  return !1;
}
function v(e) {
  return Array.isArray(e);
}
function q(e) {
  return typeof e == "function";
}
function g(e) {
  return !h(e) && !v(e) && !q(e) && typeof e == "object";
}
function h(e) {
  return typeof e == "string" || typeof e == "number" || typeof e == "boolean" || typeof e > "u" || e instanceof Date || e instanceof RegExp || e === null;
}
function ke(e, t) {
  return !(!w(e) || !w(t));
}
var Be = (
  /** @class */
  function() {
    function e() {
      var t = this;
      this._promise = new Promise(function(r, n) {
        t._resolve = r, t._reject = n;
      });
    }
    return Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.resolve = function(t) {
      this._resolve(t);
    }, e.prototype.reject = function(t) {
      this._reject(t);
    }, e;
  }()
), Me = function(e, t) {
  var r = typeof Symbol == "function" && e[Symbol.iterator];
  if (!r) return e;
  var n = r.call(e), i, o = [], a;
  try {
    for (; (t === void 0 || t-- > 0) && !(i = n.next()).done; ) o.push(i.value);
  } catch (u) {
    a = { error: u };
  } finally {
    try {
      i && !i.done && (r = n.return) && r.call(n);
    } finally {
      if (a) throw a.error;
    }
  }
  return o;
}, Ke = function(e, t, r) {
  if (r || arguments.length === 2) for (var n = 0, i = t.length, o; n < i; n++)
    (o || !(n in t)) && (o || (o = Array.prototype.slice.call(t, 0, n)), o[n] = t[n]);
  return e.concat(o || Array.prototype.slice.call(t));
}, ze = (
  /** @class */
  function() {
    function e(t, r) {
      this._callback = t, this._that = r, this._isCalled = !1, this._deferred = new Be();
    }
    return Object.defineProperty(e.prototype, "isCalled", {
      get: function() {
        return this._isCalled;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "promise", {
      get: function() {
        return this._deferred.promise;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.call = function() {
      for (var t, r = this, n = [], i = 0; i < arguments.length; i++)
        n[i] = arguments[i];
      if (!this._isCalled) {
        this._isCalled = !0;
        try {
          Promise.resolve((t = this._callback).call.apply(t, Ke([this._that], Me(n), !1))).then(function(o) {
            return r._deferred.resolve(o);
          }, function(o) {
            return r._deferred.reject(o);
          });
        } catch (o) {
          this._deferred.reject(o);
        }
      }
      return this._deferred.promise;
    }, e;
  }()
);
export {
  ze as B,
  ue as I,
  te as N,
  S as T,
  K as a,
  ge as b,
  Te as i,
  Xe as l,
  $e as m,
  Ye as s,
  We as t
};
